import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Full_body_hypertrophyIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_hypertrophy.svg';
import { ReactComponent as Upper_lower_splitIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/upper_lower_split.svg';
import { ReactComponent as Body_part_splitIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/body_part_split.svg';
import { ReactComponent as Push_pull_legsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/push_pull_legs.svg';

interface BuildMuscleStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  full_body_hypertrophy: <Full_body_hypertrophyIcon />,
  upper_lower_split: <Upper_lower_splitIcon />,
  push_pull_legs: <Push_pull_legsIcon />,
  body_part_split: <Body_part_splitIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const BuildMuscleStep3: FC<BuildMuscleStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'build_muscle',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
